<template>
  <section v-if="me" id="section__success" class="view-container">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <v-card class="mt-5 mb-5 py-15">
            <v-card-title class="font--m-2 justify-center">
              본인인증이 필요합니다.
              <br />확인버튼을 눌러 진행해 주세요
            </v-card-title>
          </v-card>
          <BasicButton @click="next" :disabled="nextLoading" :loading="nextLoading">
            확인
          </BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { locationRedirect } from '@/util'

export default {
  data() {
    return {
      nextLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  created() {
    _meta({
      titles: ['본인인증확인'],
    })
  },
  methods: {
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    async next() {
      try {
        this.nextLoading = true
        const redirect = await this.getMobileAuthUrl({
          redirectPage: `${location.origin}/kyc/verify-id`,
        })
        locationRedirect(redirect)
      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
